// extracted by mini-css-extract-plugin
module.exports =  {"item":"_93444fe79c--item--_6oLl","image":"_93444fe79c--image--ww5uR","link":"_93444fe79c--link--HEF2o"};